var map = {
	"./decidim/avatar-multiuser.png": 28584,
	"./decidim/brands/google.svg": 37942,
	"./decidim/cc-badge.png": 37427,
	"./decidim/decidim-logo.svg": 58172,
	"./decidim/default-avatar.svg": 1470,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 18828,
	"./decidim/icons.svg": 2542,
	"./decidim/pattern.png": 14131,
	"./decidim/placeholder.jpg": 30409,
	"./decidim/vendor/leaflet/layers-2x.png": 54749,
	"./decidim/vendor/leaflet/layers.png": 83004,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 37509,
	"./decidim/vendor/leaflet/marker-icon.png": 78909,
	"./decidim/vendor/leaflet/marker-shadow.png": 69189,
	"./decidim/vendor/social-share-button/delicious.svg": 70313,
	"./decidim/vendor/social-share-button/douban.svg": 77380,
	"./decidim/vendor/social-share-button/email.svg": 86378,
	"./decidim/vendor/social-share-button/facebook.svg": 5995,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 34482,
	"./decidim/vendor/social-share-button/google_plus.svg": 57131,
	"./decidim/vendor/social-share-button/hacker_news.svg": 77257,
	"./decidim/vendor/social-share-button/linkedin.svg": 70631,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 86974,
	"./decidim/vendor/social-share-button/pinterest.svg": 11173,
	"./decidim/vendor/social-share-button/qq.svg": 95958,
	"./decidim/vendor/social-share-button/reddit.svg": 16332,
	"./decidim/vendor/social-share-button/telegram.svg": 40724,
	"./decidim/vendor/social-share-button/tumblr.svg": 17301,
	"./decidim/vendor/social-share-button/twitter.svg": 96138,
	"./decidim/vendor/social-share-button/vkontakte.svg": 40896,
	"./decidim/vendor/social-share-button/wechat.svg": 88483,
	"./decidim/vendor/social-share-button/weibo.svg": 62055,
	"./decidim/vendor/social-share-button/whatsapp.svg": 45215,
	"./decidim/vendor/social-share-button/x.svg": 33823,
	"./decidim/vendor/social-share-button/xing.svg": 5620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63573;